var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.3,71.7L71.3,71.7c4.4-2.7,10.3-1.4,13,3.1l13.3,21.4c0.5-2.4,2-4.6,4.3-6h0c4-2.5,9.2-1.6,12.2,2 c0.2-2.9,1.8-5.7,4.4-7.4l0,0c4-2.5,9.2-1.6,12.2,2c0.2-2.9,1.8-5.7,4.4-7.4h0c4.4-2.7,10.5-1.5,13,3.1l18.4,33.5 c14.9,27.2-13.9,62.3-42.8,48.6l-50.2-23.7c-4.7-2.2-6.7-7.9-4.5-12.6c4.4-2.7,13.8-3.9,18.5-1.7l9.5,4.5L68.2,84.7 C65.5,80.3,66.9,74.5,71.3,71.7L71.3,71.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.9,104c-10.6-3.8-18.3-13.9-18.3-25.9C47.6,63,59.9,50.7,75,50.7c13.7,0,25.1,10.1,27.1,23.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.8,121.5C38.4,113.9,27,97.3,27,78c0-26.5,21.5-48,48-48c22.3,0,41,15.2,46.4,35.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.c8b607fea2bbe7c12e6093a37c890306.svg";
export { ForwardRef as ReactComponent };